import { BusinessRepository } from '@domain/repositories/BusinessRepository'
import { businessRepository } from '@microservices/repositories/BusinessRepository'
import { Http } from '@microservices/instances/Http'
import { API_URL } from '@assets/constants'

const http = new Http(API_URL)
export const businessRepo: BusinessRepository = businessRepository(http)
